import { defineNuxtPlugin } from "#app";
import { loadInversionBindings } from "~/app/config/inversify";
import { iocContainer } from "~/inversify.config";

export default defineNuxtPlugin(() => {
  loadInversionBindings(iocContainer);
});

